var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 19.5C1.125 21.8775 3.06 23.8125 5.4375 23.8125H18.5625C20.94 23.8125 22.875 21.8775 22.875 19.5V7.5C22.875 5.1225 20.94 3.1875 18.5625 3.1875H17.25V0.75C17.25 0.43875 16.9987 0.1875 16.6875 0.1875C16.3763 0.1875 16.125 0.43875 16.125 0.75V3.1875H7.875V0.75C7.875 0.43875 7.62375 0.1875 7.3125 0.1875C7.00125 0.1875 6.75 0.43875 6.75 0.75V3.1875H5.4375C3.06 3.1875 1.125 5.1225 1.125 7.5V19.5ZM2.25 7.5C2.25 5.74312 3.68062 4.3125 5.4375 4.3125H18.5625C20.3194 4.3125 21.75 5.74312 21.75 7.5V19.5C21.75 21.2569 20.3194 22.6875 18.5625 22.6875H5.4375C3.68062 22.6875 2.25 21.2569 2.25 19.5V7.5Z",
    fill: "#495464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 10.3125H18.1875C18.4987 10.3125 18.75 10.0612 18.75 9.75C18.75 9.43875 18.4987 9.1875 18.1875 9.1875H5.8125C5.50125 9.1875 5.25 9.43875 5.25 9.75C5.25 10.0612 5.50125 10.3125 5.8125 10.3125Z",
    fill: "#495464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 14.0625H18.1875C18.4987 14.0625 18.75 13.8112 18.75 13.5C18.75 13.1887 18.4987 12.9375 18.1875 12.9375H5.8125C5.50125 12.9375 5.25 13.1887 5.25 13.5C5.25 13.8112 5.50125 14.0625 5.8125 14.0625Z",
    fill: "#495464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 17.8125H11.4375C11.7488 17.8125 12 17.5612 12 17.25C12 16.9387 11.7488 16.6875 11.4375 16.6875H5.8125C5.50125 16.6875 5.25 16.9387 5.25 17.25C5.25 17.5612 5.50125 17.8125 5.8125 17.8125Z",
    fill: "#495464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserve);
export default __webpack_public_path__ + "static/media/reserve.c4d6243107d970c75127d27c36239f33.svg";
export { ForwardRef as ReactComponent };